import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";

import type { CommonModels } from "@/data/common/common.models";
import { ProfileQueries } from "@/data/profile/profile.queries";
import useInvalidateProfile from "@/hooks/profile/useInvalidateProfile";
import { useSse } from "@/providers/SseContext";
import { logger } from "@/util/logger";

type WorthCalcPayload = {
  status?: CommonModels.StatusEnum;
  profileType?: string;
};

export const useWorthCalcSse = () => {
  const { addEventListener } = useSse();
  const queryClient = useQueryClient();
  const { invalidateGuestProfile, invalidateProfileWorthData } = useInvalidateProfile();

  useEffect(() => {
    return addEventListener("worth-calculation:status", (payload) => {
      logger.info("[SSE] worth-calculation:status", payload);

      const data = payload.data as WorthCalcPayload;
      const status = data?.status;
      const profileType = data?.profileType;

      if (profileType === "guest-profile") {
        invalidateGuestProfile();
        return;
      }

      if (status) {
        logger.info("[SSE] Worth calculation status changed, invalidating queries", { status });

        void invalidateProfileWorthData();
        void queryClient.invalidateQueries({ queryKey: ProfileQueries.keys.getBlsSkillIndustry() });
      }
    });
  }, [addEventListener, queryClient, invalidateGuestProfile, invalidateProfileWorthData]);

  return null;
};
